import { PlaceActionType } from './place-action-type';
import { PlaceEntry } from '../../state/places';

export interface SetPlaceLocationAction {
  placeKey: string;
  location: PlaceEntry['place']['locations'][0];
  type: PlaceActionType.SetPlaceLocation;
}

export const setPlaceLocation = (
  placeKey: string,
  address: PlaceEntry['place']['locations'][0]['address'],
): SetPlaceLocationAction => ({
  placeKey,
  location: { address },
  type: PlaceActionType.SetPlaceLocation,
});
